var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lz-modal"},[_c('lz-box',[_c('div',{staticClass:"lz-modal__close",on:{"click":() => { this.$emit('close'); }}},[_c('x-icon')],1),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }